import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs/common'

export const HIERARCHY_TYPE_WITH_MANDATORY_CONTACT_HP_ROLES = [
  PartnerHierarchyType.AFFILIATE,
  PartnerHierarchyType.RESELLER_NETWORK,
]

export const HIERARCHY_TYPE_WITH_READONLY_LEGAL_INFO = [
  PartnerHierarchyType.BRANCH,
  PartnerHierarchyType.ONLINE,
]
